import { http } from "../../utils/config";

const resetAPI = {
    resetRankPoin: (id) => {
        return http.put(`/api/v1/ranking-resets/${id}`);
    },

    toggleStatusVoiceCall: (id) => {
        return http.patch(`/api/v1/ranking-resets/${id}/status-voice-call`);
    },

    toggleStatusResetRankPoint: (id) => {
        return http.patch(`/api/v1/ranking-resets/${id}/status-reset-rank-point`);
    },

    toggleStatusActiveAccount: (id) => {
        return http.patch(`/api/v1/ranking-resets/${id}/status-account`);
    },
};

// Helper functions for handling API responses
export const templateHelpers = {
    // Validate data before submission
    validateTemplateData: (templateData) => {
        const errors = {};

        if (!templateData.name?.trim()) {
            errors.name = 'Tên khách hàng không được để trống';
        }

        return {
            isValid: Object.keys(errors).length === 0,
            errors
        };
    }
};

// Error handling wrapper
export const withErrorHandling = (apiFunction) => {
    return async (...args) => {
        try {
            const response = await apiFunction(...args);
            return response;
        } catch (error) {
            console.error('API Error:', error);

            // Handle different types of errors
            if (error.response) {
                // Server responded with error status
                const { status, data } = error.response;
                switch (status) {
                    case 400:
                        throw new Error(data.message || 'Dữ liệu không hợp lệ');
                    case 401:
                        throw new Error('Bạn cần đăng nhập để thực hiện thao tác này');
                    case 403:
                        throw new Error('Bạn không có quyền thực hiện thao tác này');
                    case 404:
                        throw new Error('Không tìm thấy khách hàng');
                    case 422:
                        throw new Error(data.message || 'Dữ liệu không hợp lệ');
                    case 500:
                        throw new Error(data.message || "Lỗi server, vui lòng thử lại sau");
                    default:
                        throw new Error(data.message || 'Đã có lỗi xảy ra');
                }
            } else if (error.request) {
                // Network error
                throw new Error('Không thể kết nối đến server');
            } else {
                // Other error
                throw new Error(error.message || 'Đã có lỗi xảy ra');
            }
        }
    };
};

// Wrapped API functions with error handling
export const resetAPIWithErrorHandling = {
    resetRankPoin: withErrorHandling(resetAPI.resetRankPoin),
    toggleStatusVoiceCall: withErrorHandling(resetAPI.toggleStatusVoiceCall),
    toggleStatusResetRankPoint: withErrorHandling(resetAPI.toggleStatusResetRankPoint),
    toggleStatusActiveAccount: withErrorHandling(resetAPI.toggleStatusActiveAccount),
};

export default resetAPI;